import { createContext, useContext, useState, useCallback } from "react";
import {
  api,
  getToken,
  setToken,
  clearToken,
  getStoredUser,
  setStoredUser,
} from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setTok] = useState(() => getToken());
  const [user, setUser] = useState(() => getStoredUser());

  const login = useCallback(async (email, password) => {
    const data = await api.login(email, password);
    if (!data?.session_token) throw new Error("Invalid response from server");
    setToken(data.session_token);
    setStoredUser(data.user || null);
    setTok(data.session_token);
    setUser(data.user || null);
    return data;
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setTok(null);
    setUser(null);
    window.location.assign("/mypersonalworkplace/login");
  }, []);

  return (
    <AuthContext.Provider value={{ token, user, isAuthed: !!token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
